module.exports = __webpack_public_path__ + "img/gopay.47f67b7f.png";